/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import "./src/assets/css/global.css";

import React from "react";
import Root from "./src/components/Root";

export const wrapRootElement = ({ element }) => {
    return <Root>{element}</Root>;
};
